import Vue from "vue";

import {PersonnelService} from "@/common/api.service";

import {
    FETCH_PERSON_EMERGENCY_CONTACTS_END,
    LOAD_PERSON_EMERGENCY_CONTACT_TO_EDIT,
    LOAD_PERSON_EMERGENCY_CONTACT_TO_VIEW,
    RESET_DEFAULT_NEW_PERSON_EMERGENCY_CONTACT,
    RESET_DEFAULT_PERSON_EMERGENCY_CONTACT_TO_EDIT,
    TOGGLE_EDIT_PERSON_EMERGENCY_CONTACT_DIALOG,
    TOGGLE_NEW_PERSON_EMERGENCY_CONTACT_DIALOG,
    TOGGLE_PERSON_EMERGENCY_CONTACT_EDIT_STATE,
    TOGGLE_VIEW_PERSON_EMERGENCY_CONTACT_DIALOG,
    UPDATE_ADD_PERSON_EMERGENCY_CONTACT_FIELD,
    UPDATE_EDIT_PERSON_EMERGENCY_CONTACT_FIELD,
    UPDATE_NEW_PERSON_EMERGENCY_CONTACT,
} from "./mutations.js";
import {DELETE_PERSON_EMERGENCY_CONTACT, FETCH_PERSON_EMERGENCY_CONTACT_LIST, SAVE_EDITED_PERSON_EMERGENCY_CONTACT, SAVE_NEW_PERSON_EMERGENCY_CONTACT} from "./actions.js"
import {SET_TOASTER_MESSAGE} from "../this_app/mutations";


const state = {
    relationshipTypeList: ["Friend", "Other", "Parent", "Partner", "Spouse"],
    personEmergencyContactList: [],
    editStateEmergencyContact: {
        personId: false,
        relationship: false,
        mobile: false,
        startDate: false,
        endDatetime: false,
        comments: false,
        telephone: false,
        telephoneWork: false,
        addressLineOne: false,
        addressLineTwo: false,
        town: false,
        county: false,
        personnelCountryId: false,
        postCode: false,
        email: false,
    },
    newPersonEmergencyContact: {
        personId: false,
        relationship: false,
        mobile: false,
        startDate: false,
        endDatetime: false,
        comments: false,
        telephone: false,
        telephoneWork: false,
        addressLineOne: false,
        addressLineTwo: false,
        town: false,
        county: false,
        personnelCountryId: false,
        postCode: false,
        email: false,
    },
    addPersonEmergencyContact: {},
    editPersonEmergencyContact: {},
    viewPersonEmergencyContact: {},
    addPersonEmergencyContactDialog: false,
    editPersonEmergencyContactDialog: false,
    viewPersonEmergencyContactDialog: false,
};

const getDefaultState = () => {
    return {
        defaultPersonEmergencyContact: {
            personId: false,
            name: undefined,
            relationship: undefined,
            mobilePhone: undefined,
            startDate: undefined,
            endDatetime: undefined,
            comments: undefined,
            telephone: undefined,
            telephoneWork: undefined,
            addressLineOne: undefined,
            addressLineTwo: undefined,
            town: undefined,
            county: undefined,
            personnelCountryId: undefined,
            postCode: undefined,
            emailAddress: undefined,
        },
    }
};

const getters = {
    relationshipTypeList(state) {
        return state.relationshipTypeList;
    },
    personEmergencyContactList(state) {
        return state.personEmergencyContactList;
    },
    editStateEmergencyContact(state) {
        return state.editStateEmergencyContact;
    },
    viewPersonEmergencyContactDialog(state) {
        return state.viewPersonEmergencyContactDialog;
    },
    addPersonEmergencyContactDialog(state) {
        return state.addPersonEmergencyContactDialog;
    },
    editPersonEmergencyContactDialog(state) {
        return state.editPersonEmergencyContactDialog;
    }
};

const actions = {
    [FETCH_PERSON_EMERGENCY_CONTACT_LIST]({commit}, personId) {
        return PersonnelService.getPersonEmergencyContacts(personId)
            .then(({data}) => {
                commit(FETCH_PERSON_EMERGENCY_CONTACTS_END, data);
            })
            .catch(error => {
                Vue.rollbar.error(error);
                commit(SET_TOASTER_MESSAGE, {state: true, value: 'Failed to fetch emergency contacts'});
            });
    },
    [SAVE_NEW_PERSON_EMERGENCY_CONTACT]({commit, dispatch}) {
        //Put this here as it will get lost with reset
        const newPersonEmergencyContact = state.addPersonEmergencyContact;
        return PersonnelService.savePersonEmergencyContact(newPersonEmergencyContact)
            .then(() => {

                commit(SET_TOASTER_MESSAGE, {state: true, value: 'Record saved'});
                dispatch(FETCH_PERSON_EMERGENCY_CONTACT_LIST, newPersonEmergencyContact.personId);
                // return data;
            })
            .catch(error => {
                Vue.rollbar.error(error);
                commit(SET_TOASTER_MESSAGE, {state: true, value: 'Failed to save emergency contact'});
            });
    },

    [SAVE_EDITED_PERSON_EMERGENCY_CONTACT]({commit, dispatch}) {
        //Put this here as it will get lost with reset
        const editedPersonEmergencyContact = state.editPersonEmergencyContact;
        return PersonnelService.updatePersonEmergencyContact(editedPersonEmergencyContact)
            .then(({data}) => {
                commit(RESET_DEFAULT_PERSON_EMERGENCY_CONTACT_TO_EDIT);
                dispatch(FETCH_PERSON_EMERGENCY_CONTACT_LIST, editedPersonEmergencyContact.personId);
                return data;
            })
            .catch(error => {
                Vue.rollbar.error(error);
                commit(SET_TOASTER_MESSAGE, {state: true, value: 'Failed to update emergency contact'});
            });
    },


    [DELETE_PERSON_EMERGENCY_CONTACT]({dispatch, commit}, params) {

        return PersonnelService.deletePersonEmergencyContact(params.personEmergencyContactId)
            .then(({data}) => {
                commit(SET_TOASTER_MESSAGE, {state: true, value: 'Record deleted'});
                dispatch(FETCH_PERSON_EMERGENCY_CONTACT_LIST, params.personId);
                return data;
            })
            .catch(error => {
                Vue.rollbar.error(error);
                commit(SET_TOASTER_MESSAGE, {state: true, value: 'Failed to delete emergency contacts'});
            });
    },
};

/* eslint no-param-reassign: ["error", { "props": false }] */
const mutations = {
    [TOGGLE_NEW_PERSON_EMERGENCY_CONTACT_DIALOG](state) {
        state.addPersonEmergencyContactDialog = !state.addPersonEmergencyContactDialog;
    },
    [TOGGLE_EDIT_PERSON_EMERGENCY_CONTACT_DIALOG](state) {
        state.editPersonEmergencyContactDialog = !state.editPersonEmergencyContactDialog;
    },
    [TOGGLE_VIEW_PERSON_EMERGENCY_CONTACT_DIALOG](state) {
        state.viewPersonEmergencyContactDialog = !state.viewPersonEmergencyContactDialog;
    },
    [RESET_DEFAULT_NEW_PERSON_EMERGENCY_CONTACT](state, personId) {
        state.addPersonEmergencyContact = getDefaultState().defaultPersonEmergencyContact;

        state.addPersonEmergencyContact.personId = personId;
    },
    [RESET_DEFAULT_PERSON_EMERGENCY_CONTACT_TO_EDIT](state) {
        state.editPersonEmergencyContact = getDefaultState().defaultPersonEmergencyContact;
    },

    [LOAD_PERSON_EMERGENCY_CONTACT_TO_EDIT](state, emergencyContactId) {
        // noinspection UnnecessaryLocalVariableJS
        const itemToEdit = state.personEmergencyContactList.find((list) =>
            list.personEmergencyContactId == emergencyContactId);
        state.editPersonEmergencyContact = itemToEdit;
    },

    [LOAD_PERSON_EMERGENCY_CONTACT_TO_VIEW](state, emergencyContactId) {
        // noinspection UnnecessaryLocalVariableJS
        const itemToView = state.personEmergencyContactList.find((list) =>
            list.personEmergencyContactId == emergencyContactId);
        state.viewPersonEmergencyContact = itemToView;
    },

    [UPDATE_ADD_PERSON_EMERGENCY_CONTACT_FIELD](state, data) {
        if (data.objectKey !== undefined) {
            state.addPersonEmergencyContact[data.objectKey][0][data.key] = data.value;
        } else {
            state.addPersonEmergencyContact[data.key] = data.value;
        }
    },

    [UPDATE_EDIT_PERSON_EMERGENCY_CONTACT_FIELD](state, data) {
        if (data.objectKey !== undefined) {
            state.editPersonEmergencyContact[data.objectKey][0][data.key] = data.value;
        } else {
            state.editPersonEmergencyContact[data.key] = data.value;
        }
    },

    [TOGGLE_PERSON_EMERGENCY_CONTACT_EDIT_STATE](state, field) {
        state.editStateEmergencyContact[field] = !state.editStateEmergencyContact[field];
    },
    [FETCH_PERSON_EMERGENCY_CONTACTS_END](state, data) {
        state.personEmergencyContactList = data;
    },
    [UPDATE_NEW_PERSON_EMERGENCY_CONTACT](state, data) {
        if (data.objectKey !== undefined) {
            state.newPersonEmergencyContact[data.objectKey][0][data.key] = data.value;
        } else {
            state.newPersonEmergencyContact[data.key] = data.value;
        }
    },
};

export default {
    state,
    getters,
    actions,
    mutations,
};
